<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot="menuLeft">
                <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('活动报名', '报名人（提交用户）、工号（提交用户）、部门（提交用户）、手机号（提交用户）、姓名、性别、身份（员工、家属-成人、家属-儿童）、身份证号、身高', defaultParams)">导出Excel
                </el-button>
            </template>
        </avue-crud>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  export default {
    mixins: [curd],
    name: 'ActivityUser',
    props: ['defaultParams'],
    data() {
      return {
        dialogCamerataUserVisible: false,
        dialogCamerataActivityVisible: false,
        url: '/activity/user',
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增同好会', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          delBtn: true, // 删除按钮显隐
          delBtnText: '取消报名', // 新增按钮文案
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          menu: true,
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '报名人',
              prop: 'user-username',
              span: 24,
            },
            {
              label: '工号',
              prop: 'user_id',
              search: true,
              span: 24,
            },
            {
              label: '所属部门',
              prop: 'user-class',
              span: 24,
            },
            {
              label: '手机号',
              prop: 'user-tel',
              span: 24,
            },
            {
              label: '姓名',
              prop: 'name',
              span: 24,
            },
            {
              label: '性别',
              prop: 'sex',
              type: 'select',
              span: 24,
              dicData: [{label: '未知', value: 0}, {label: '男', value: 1}, {label: '女', value: 2}]
            },
            {
              label: '身份',
              prop: 'status',
              type: 'select',
              span: 24,
              dicData: [{label: '员工', value: 1}, {label: '家属-成人', value: 2}, {label: '家属-儿童', value: 3}]
            },
            {
              label: '身份证号',
              prop: 'id_num',
              span: 24,
            },
            {
              label: '身高',
              prop: 'height',
              span: 24,
            },
          ]
        }
      }
    },
    methods: {
      // 导出Excel文件统一处理
      excelExport(filename = new Date().getTime(), field, item) {
        console.log(item);
        this.$confirm('导出将由服务器后端执行，需要时间等待，完成后会在右上角提示下载，该导出包含以下内容: ' + field, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const message = this.$notify({
            title: '通知',
            message: '服务器处理中...',
            showClose: false,
            duration: 0
          });
          this.api.get(this.url + '/export?filename=' + filename + '&id='+item.activityId, this.searchParams).then((re) => {
            message.close()
            if (re.code === 0) {
              let url = this.config.baseURL + '/excel/download/' + re.data;
              this.$notify({
                title: '导出成功!',
                dangerouslyUseHTMLString: true,
                type: 'success',
                duration: 0, // 不会自动关闭的消息
                message: filename + '数据导出完成 下载导出文件:<a target="_blank" href="' + url + '">下载' + filename + 'Excel</a>'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });
        });
      }
    }
  }
</script>
